import { Failure } from '@geekbears/gb-ngrx-stack-base';
import { GetUserDetailsResponse } from '@modules/company-manager/users/domain';
import { createAction, props } from '@ngrx/store';
import {
  ChangePasswordParams,
  updateProfile,
} from '../../domain/entities/profile.entity';

/**
 * Actions For Update Profile Data
 */
export const updateProfileDataAction = createAction(
  '[Profile] Update Profile Data Action',
  props<{
    data: updateProfile;
  }>()
);
export const updateProfileDataSuccessAction = createAction(
  '[Profile] Update Profile Data Success Action',
  props<{
    response: any;
  }>()
);
export const updateProfileDataFailureAction = createAction(
  '[Profile] Update Profile Data Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Update Password
 */
export const updatePasswordAction = createAction(
  '[Profile] Update Password Action',
  props<{
    userData: Omit<ChangePasswordParams, 'userId'>;
  }>()
);
export const updatePasswordSuccessAction = createAction(
  '[Profile] Update Password Success Action',
  props<{
    response: GetUserDetailsResponse;
  }>()
);
export const updatePasswordFailureAction = createAction(
  '[Profile] Update Password Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Update Photo
 */
export const updatePhotoAction = createAction(
  '[Profile] Update Photo Action',
  props<{
    photo: any;
  }>()
);
export const updatePhotoSuccessAction = createAction(
  '[Profile] Update Photo Success Action',
  props<{
    response: any;
  }>()
);
export const updatePhotoFailureAction = createAction(
  '[Profile] Update Photo Failure Action',
  props<{
    failure: Failure;
  }>()
);
export const ProfileActions = {
  /**
   * Actions For Update Email
   */
  updateProfileData: updateProfileDataAction,
  updateProfileDataSuccess: updateProfileDataSuccessAction,
  updateProfileDataFailure: updateProfileDataFailureAction,

  /**
   * Actions For Update Password
   */
  updatePassword: updatePasswordAction,
  updatePasswordSuccess: updatePasswordSuccessAction,
  updatePasswordFailure: updatePasswordFailureAction,

  /**
   * Actions For Update Photo
   */
  updatePhoto: updatePhotoAction,
  updatePhotoSuccess: updatePhotoSuccessAction,
  updatePhotoFailure: updatePhotoFailureAction,
};
